/** @license @dairyfarm/eval-web v3.0.0
* Copyright 2020 Texas A&M Center for Applied Technology, 
* Texas A&M Engineering Experiment Station, The Texas A&M 
* University System.
* 
* This source code/schema and any derivative work is Texas 
* A&M Engineering Experiment Station intellectual property 
* and protected by copyright law. Usage is restricted solely 
* to the FARM Animal Care and Environmental Stewardship 
* programs administered by the National Milk Producers 
* Federation. Dissemination of this source code and/or 
* derivative work creation is strictly prohibited without 
* express written permission from the Texas A&M Engineering 
* Experiment Station.
*/
import moment from 'moment';
import { getType } from 'typesafe-actions';
import { AppAction } from '..';
import { signOutAction } from '../session';
import { Facility } from './../../db/stores/facilities';
import { getFacilities, setCurrentFacilityAction } from './actions';

export type FacilityMap = { [facilityid: string]: Facility };

export interface FacilitiesState {
  items: FacilityMap;
  fetching: boolean;
  lastFetch?: string | null;
  error?: Error;
  currentFacility: Facility | undefined;
}

export const facilitiesReducer: (state: FacilitiesState | undefined, action: AppAction) => FacilitiesState = (
  state: FacilitiesState = {
    fetching: true,
    items: {},
    currentFacility: undefined
  },
  action
) => {
  
  switch (action.type) {

    case getType(getFacilities.request):
      return {
        ...state,
        fetching: true
      };

    case getType(getFacilities.success):
      return {
        ...state,
        items: action.payload.reduce((acc: FacilityMap, curr: Facility) => {
          return {
            ...acc,
            [curr.id]: curr,
          };
        }, {}),
        fetching: false,
        lastFetch: moment().toISOString()
      };

    case getType(getFacilities.failure):
      return {
        ...state,
        fetching: false
      };

    case getType(signOutAction):
      return {
        fetching: false,
        items: {},
        currentFacility: undefined
      }

    case getType(setCurrentFacilityAction):
      if (!action.payload) {
        return {
          ...state,
          currentFacility: undefined
        }
      }

      if (typeof action.payload === 'string') {
        return {
          ...state,
          currentFacility: state.items[action.payload]
        }
      }

      return {
        ...state,
        currentFacility: action.payload
      }
  }

  return state;
};
